import moment from "moment";

export class JSONConfigController {
    static $inject: string[] = ["ObjectDiff"];
    activeConfig: any;
    configurations: any[] = [];
    configFromFile: boolean = false;
    configCategories = null;
    schema: any = {};
    fileConfiguration: any;
    onCreateConfig!: Function;
    onSetActiveConfig!: Function;
    onDeleteConfig!: Function;
    comparedVersion: any = null;
    compareCandidateVersions: any[] = []
    diffValueChanges: any;
    dateFormat: string = "DD/MM/YYYY HH:mm:ss";

    private _objectDiff: any;

    public options: any =  {
        modes: ['tree', 'code'],
        mode: 'code',
        schema: this.schema,
        onEditable: (node) => {
            const schema = this.schema;
            if (schema && node && node.field) {
                let ignoreNext = false;
                const currentProperty = node.path && node.path.reduce((acc, current) => {
                    if (!ignoreNext && acc.properties && acc.properties[current]) {
                        if (acc.properties[current].type === 'array') {
                            ignoreNext = true;
                            return acc.properties[current].items
                        } else {
                            ignoreNext = false;
                            return acc.properties[current]
                        }
                    } else {
                        ignoreNext = false;
                        return acc;
                    }
                }, schema)
                return currentProperty ? !currentProperty.readonly : true; 
            }
            return true
        }
    };

    constructor(ObjectDiff) {
        this._objectDiff = ObjectDiff;
    }


    $onChanges(changes) {
        if (changes.configFromFile) {
          this.configFromFile = changes.configFromFile.currentValue;
        }
        if (changes.configurations) {
            this.configurations = changes.configurations.currentValue;
            this.configurations = this.configurations && this.configurations.map(configuration => {
                configuration.activatedOn = configuration.activatedOn ? this._timestampToDatestring(configuration.activatedOn) : null;
                configuration.createdOn = configuration.createdOn ? this._timestampToDatestring(configuration.createdOn) : null;
                return configuration;
            })
        }
        if (changes.configCategories) {
            this.configCategories = changes.configCategories.currentValue;
        }
        if (changes.schema) {
            this.schema = changes.schema.currentValue;
        }

        this.activeConfig = this.configFromFile ? this.fileConfiguration && this.fileConfiguration.data : this.configurations[0];
        this._setCompareCandidateVersions();
    }

    show = (configuration: any) => {
        this.activeConfig = configuration;
        this._setCompareCandidateVersions();
        this.onCompareWithChanged();
    };
    
    setActive = async (config: any) => {
        config.createdOn = config.createdOn ? this._datestringToTimestamp(config.createdOn) : null;
        config.activatedOn = new Date().getTime();
        this.onSetActiveConfig({config});
    }

    delete = async (config: any) => {
        this.onDeleteConfig({config});
    }

    _timestampToDatestring = (timestamp: number) => {
        // const date = new Date(timestamp);
        return moment(timestamp).format(this.dateFormat);
    }

    _datestringToTimestamp = (dateString: string) => {
        return moment(dateString, this.dateFormat).toDate().getTime()
    }

    _setCompareCandidateVersions = () => {
        this.compareCandidateVersions = this.configurations && this.configurations.filter(configuration => configuration.version !== this.activeConfig.version )
    }


    cancelCompare = () => this.comparedVersion = null

    onCompareWithChanged = () => {
        if (this.activeConfig && this.comparedVersion) {
            const activeConfig = this._removeExtraProperties({...this.activeConfig});
            const compareTo = this._removeExtraProperties({...this.comparedVersion});

            this.diffValueChanges = this._objectDiff.diff(activeConfig, compareTo);
        }
    }

    _removeExtraProperties = (jsonObject: any) => {
        if (Object.keys(jsonObject).length > 0) {
            delete jsonObject.$$hashKey;
            delete jsonObject._id;
            delete jsonObject.activatedOn;
            delete jsonObject.createdOn;
        }
        return jsonObject;
    }


    editorLoaded = (jsonEditor) => {
        /*setTimeout(() => {     
            jsonEditor.expandAll();
            for (let i=0; i < jsonEditor.node.childs.length; i++) {
                const node = jsonEditor.node.childs[i];
                this.addTooltip(node);  
            }
        }, 100);*/
     };

     addTooltip = (node) => {
        const current:HTMLDivElement =  node.dom.field;

        if (current) {
            if (node.field) {
                const id = "#" + this.generateNodeId(node,'');
                let matchedNodes;
                if (this.schema && this.schema.properties) {
                    matchedNodes = this.search(this.schema.properties, (key, value) => { // im looking for this key value pair
                        return key === '$id' && value === id;
                    });
                }

                const tooltipText =  matchedNodes && matchedNodes[0] ? matchedNodes[0].description || matchedNodes[0].title : node.field;
                current.innerHTML = `${current.innerHTML} <dfn><i class="fa fa-info-circle"></i>
                                    <object class="dfn-tooltip">
                                    <div class="panel panel-default">
                                        <div class="panel-heading"><strong>${current.innerHTML}</strong> </div>
                                        <div class="panel-body">${tooltipText}</div>
                                    </div>
                                        
                                    </object>
                                    </dfn>`;
            }
            if (node.childs && node.childs.length > 0) {
                node.childs.forEach(node => {
                   this.addTooltip(node);
                })
            }
        }
     }

     generateNodeId  = (node, id) => {
         id = "/properties/" + node.field + id;
         if (node.parent && node.parent.field) {
             return this.generateNodeId(node.parent, id)
         } else {
            
            if (node.parent.parent && node.parent.parent.field) {
                id = '/items' + id;
                return this.generateNodeId(node.parent.parent, id)
            } 
         }
         return id;
     }


     search = (obj, predicate) => {
        let result: any[] = []; 
        for(let p in obj) { // iterate on every property
            // tip: here is a good idea to check for hasOwnProperty
            if (typeof(obj[p]) == 'object') { // if its object - lets search inside it
                result = result.concat(this.search(obj[p], predicate));
            } else if (predicate(p, obj[p])) 
                result.push(
                   obj
                ); // check condition
        }
        return result;
    }
}